export const lessonTypeMapping = {
  INDIVIDUAL: "개인",
  GROUP: "그룹",
  CONSULT: "상담"
};

export const lessonLogStatusMapping = {
  RESERVE: "예약",
  WAIT: "대기"
}